import type { OptionTypeBase } from 'react-select';
//FIX ME after updating to react-select v5 with proper typescript
// eslint-disable-next-line import/namespace
import type { NoticeProps as ReactSelectNoticeProps } from 'react-select/src/components/Menu';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { useSelectStyles } from '../SelectStylesContext';

export type LoadingMessageProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectNoticeProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const LoadingMessage = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
  children,
}: LoadingMessageProps<OptionType, IsMulti>) => {
  const { loadingMessage: loadingMessageStyles } = useSelectStyles();

  return (
    <Box __css={loadingMessageStyles} {...innerProps}>
      {children}
    </Box>
  );
};
